import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  ToastContainer,
  Toast,
  Button,
  InputGroup,
  Modal,
  Table,
  FormCheck,
  ListGroup,
  ProgressBar,
} from "react-bootstrap";
import {
  CheckIcon,
  CalendarIcon,
  ClockIcon,
  PlusIcon,
  CheckCircleIcon,
  ShieldExclamationIcon,
} from "@heroicons/react/solid";
import { DropFilesForm } from "components/Forms";
import { AiFillMessage } from "react-icons/ai";
import { IoLogoWhatsapp, IoMdAddCircle } from "react-icons/io";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { XCircleIcon } from "@heroicons/react/outline";
import { RiDeleteBin6Line } from "react-icons/ri";
import {
  useVerifyCampaignNameMutation,
  useContactGetUploadListMutation,
  useGetSMSTemplatesMutation,
  useGetWhatsappTemplatesMutation,
  useCreateCampaignMutation,
  useCampaignFileMutation,
  useWabaForEuMutation,
  useGetRoutesOfEAMutation,
  useGetShortUrlsMutation,
  useRoutesOfEAForEUMutation,
  useCountriesOptionsMutation,
  useSenderListsMutation,
  useCategoriesByEntMutation,
  useCreateSMSTemplateMutation,
} from "Services/services";
import Select from "react-select";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import "../../components/ProgressSteps.css"; // Steps CSS
import ProgressSteps from "components/progressStep";
import CopyToClipboard from "react-copy-to-clipboard";
import SmsCalculator from "pages/SmsCalculator";
import { RiInformationLine } from "react-icons/ri";
import { useHistory } from "react-router-dom";
import { Routes } from "routes";
import EmojiPicker from "emoji-picker-react";
import { FaSmile } from "react-icons/fa";
import { MobilePreviews } from "./mobilePreviews";
import { BiSolidMessageSquareDetail } from "react-icons/bi";
import { useGetRegisteredRcsTemplatesMutation } from "../../Services/rcsServices";
import { useGetRcsAssignedRoutesMutation } from "../../Services/rcsServices";
import { RCS_PROVIDERS } from "../../utils/constant";

const { KARIX, SMART_PING } = RCS_PROVIDERS;

// const userID = JSON.parse(localStorage.getItem("user").id)

export const BulkComponent = () => {
  const history = useHistory();
  const [getRegisteredRcsTemplates] = useGetRegisteredRcsTemplatesMutation();
  const [getRcsAssignedRoutes] = useGetRcsAssignedRoutesMutation();
  const [dataType, setDataType] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [conditions, setConditions] = useState([]);
  const [showCondition, setShowCondition] = useState(false);
  const [nextId, setNextId] = useState(2);
  const [verify] = useVerifyCampaignNameMutation();
  const [getCountries] = useCountriesOptionsMutation();
  const [SenderList] = useSenderListsMutation();
  const [getContactList] = useContactGetUploadListMutation();
  const [getSMSTemplateList] = useGetSMSTemplatesMutation();
  const [getWhatsappTemplateList] = useGetWhatsappTemplatesMutation();
  const [createTemp] = useCreateSMSTemplateMutation();
  const [CategoriesData] = useCategoriesByEntMutation();
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [newTempName, setNewTempName] = useState(null);
  const [newTemplatetext, setNewTemplateText] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [progress, setProgress] = useState(0);
  const [reason, setReason] = useState("");
  const [variant, setVariant] = useState("primary");

  const [isVerifiedCampaign, setisVerifiedCampaign] = useState();
  const [contactList, setContactList] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [templateLists, setTemplateLists] = useState([]);
  const [contact, setContact] = useState();
  const [template, setTemplate] = useState();
  const [api, setApi] = useState(""); // Store the search string
  const [selected, setSelected] = useState("");
  const [internationalSms, setInternationalSms] = useState(false);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [startDate, setStartDate] = useState(moment()); // Initialize with current date/time using moment
  const [endDate, setEndDate] = useState(null); // Set as null initially
  const [startTime, setStartTime] = useState(moment());
  // const [endTime, setEndTime] = useState(null);
  const [activePeriod, setActivePeriod] = useState(""); // Default selection
  const [scheduling, setScheduling] = useState("OneTime"); // Default selection
  const [selectedDays, setSelectedDays] = useState([]);
  const [sendNow, setSendNow] = useState(false);

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const enterprise_id = userObject.associated_enterprise_id;
  const userOwnId = userObject.id;

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [senderOptions, setSenderOptions] = useState([]);
  const [senderID, setSenderID] = useState(null);

  const [templateModal, setTemplateModal] = useState(false);
  const handleCloseTemplate = () => {
    setTemplateModal(false);
    setSubmitted(false);
  };

  const [whatsappBulkFile, setWhatsappBulkFile] = useState("");

  const [selectedWeekdays, setSelectedWeekdays] = useState([]);
  const [selectedWeekday, setSelectedWeekday] = useState("");

  const [contactForm, setContactForm] = useState({
    // list_name: '',
    // remark: '',
    file: "",
  });
  const [uploadList] = useCreateCampaignMutation();

  const [templateContent, setTemplateContent] = useState([]);
  const [templateCondContent, setTemplateCondContent] = useState([]);
  const [count, setCount] = useState(1);

  const [templateContents, setTemplateContents] = useState("");
  const [whatsappTemplateContents, setWhatsappTemplateContents] = useState([]);
  const [previewContents, setPreviewContents] = useState("");
  const [previewContents2, setPreviewContents2] = useState("");

  const [category, setCategory] = useState();
  const [showDefault, setShowDefault] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const [copied, setCopied] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [rcsProvider, setRcsProvider] = useState(false);
  const emojiPickerRef = useRef(null);
  const textareaRef = useRef(null);

  const [smsDetails, setSmsDetails] = useState({
    textLength: 0,
    remaining: 0,
    numberOfSMS: 1,
    encoding: "GSM 7",
  });

  const [errors, setErrors] = useState({
    campaignName: "",
    messageType: "",
    country: "",
    template: "",
    waba: "",
    route: "",
    conditions: [],
    scheduling: "",
    startDate: "",
    endDate: "",
    startTime: "",
    activePeriod: "",
  });

  const [campaignFileData] = useCampaignFileMutation();
  const [tr, setTR] = useState(0);
  const [vr, setVR] = useState(0);
  const [ir, setIR] = useState(0);

  // const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  // const emojiPickerRef = useRef(null);

  const handlePeriodChange = (event) => {
    setActivePeriod(event.target.value); // Update the selected active period
    // Reset selections when changing period
    setSelectedDays([]);
    setSelectedWeekdays([]);
    setSelectedWeekday("");
  };

  const handleScheduleChange = (event) => {
    setSendNow(false);
    setScheduling(event.target.value); // Update the selected active period
    // Reset selections when changing period
    setSelectedDays([]);
    setSelectedWeekdays([]);
    setSelectedWeekday("");
  };

  const renderDaysButtons = () => {
    const handleInfoIconClick = () => {
      // This can show a tooltip or modal with more information if desired
      alert(
        "The campaign will skip months that do not contain the selected date."
      );
    };

    return (
      <div>
        <div className="d-flex flex-wrap">
          {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
            <Button
              key={day}
              variant={selectedDays === day ? "secondary" : "outline-secondary"}
              onClick={() => toggleDaySelection(day)}
              style={{ margin: "5px" }}
            >
              {day}
            </Button>
          ))}
        </div>

        {(selectedDays === 29 ||
          selectedDays === 30 ||
          selectedDays === 31) && (
          <div className="info-container mt-2 d-flex align-items-center">
            <RiInformationLine
              size={20}
              style={{ marginRight: "8px", color: "orange" }}
              onClick={handleInfoIconClick}
            />
            <span style={{ marginRight: "8px", color: "#F1A034" }}>
              Note: The campaign will skip months that do not contain the
              selected day (e.g., February for 29th, April for 30th).
            </span>
          </div>
        )}
      </div>
    );
  };

  const toggleDaySelection = (day) => {
    setSelectedDays(day); // update the selected day to only one value
  };

  const renderWeekdaysButtons = () => {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return (
      <div className="d-flex flex-wrap">
        {weekdays.map((weekday, index) => (
          <Button
            key={index}
            variant={
              selectedWeekdays === index ? "secondary" : "outline-secondary"
            }
            onClick={() => toggleWeekdaySelection(index)}
            style={{ margin: "5px" }}
          >
            {weekday}
          </Button>
        ))}
      </div>
    );
  };

  const toggleWeekdaySelection = (index) => {
    setSelectedWeekdays(index); // update the selected weekday to only one index at a time
  };

  const handleDateTime = () => {
    setSendNow(true);

    const now = moment();

    // Use the existing logic to keep startDate consistent
    handleStartChange(now);

    // ✅ Set time as moment object (just like Datetime gives)
    setStartTime(moment(now.format("HH:mm"), "HH:mm"));

    setErrors((prevErrors) => ({
      ...prevErrors,
      startTime: "",
      startDate: "",
    }));
  };

  const handleStartChange = (date) => {
    if (date.isSame(moment(), "day")) {
      setSendNow(true);
    } else {
      setSendNow(false);
    }
    if (date && date.isValid()) {
      setStartDate(date); // Set start date to the selected date
      // Ensure end date is not before the new start date
      if (date.isAfter(endDate)) {
        setEndDate(date.clone()); // Set end date to match new start date if necessary
      }
    }
  };

  const handleStartTimeChange = (time) => {
    setSendNow(false);

    if (time && time.isValid()) {
      setStartTime(time);
    }
  };

  const handleEndChange = (date) => {
    if (date && date.isValid() && date.isSameOrAfter(startDate)) {
      setEndDate(date); // Only set end date if it's after or equal to start date
    }
  };

  const handleDataType = (e) => {
    setDataType(e.target.id);
    setErrors({ ...errors, dataType: "" });
  };

  useEffect(() => {
    fetchCampaignList();
  }, [dataType, selected]);

  useEffect(() => {
    if (conditions[0]?.message) {
      fetchTemplateListCondition(conditions[0].message);
    }
    // if (conditions.length === 0) {
    //   setConditions([{ id: 1, type: "", message: "", template: "" }]);
    // }
  }, [conditions, dataType, conditions[0]?.message, selected]);

  const handleInput = (e) => {
    fetchTemplateData(e.label);
  };

  const handleCountry = (option) => {
    setSelectedCountry(option);
    setSenderID(null);
    setTemplate(null);
    setTemplateContents("");
    setErrors({ ...errors, country: "" });
    if (
      option.value === "United Arab Emirates" ||
      option.value === "Saudi Arabia"
    ) {
      fetchSenderOptions(option.value);
      setInternationalSms(true);
    } else {
      setInternationalSms(false);
    }
  };

  const [tempErrors, setTempErrors] = useState({
    name: false,
    classification: false,
    tempText: false,
  });
  const [validated, setValidated] = useState(false);

  const submitNewTemp = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isNameValid = !!newTempName;
    const isCategoryValid = !!selectedCategory;
    const istextValid = !!newTemplatetext;

    if (isNameValid && isCategoryValid && istextValid) {
      setSubmitted(true);
      createTemp({
        template_name: newTempName,
        category: selectedCategory.value,
        template_content: newTemplatetext,
        country: selectedCountry.value,
      })
        .then((success) => {
          if (
            success?.data?.statusCode >= 200 &&
            success?.data?.statusCode <= 204
          ) {
            setReason(success?.data?.message);
            setVariant("tertiary");
            setProgress(100);
            //for UI - new template auto selection
            fetchTemplateList("SMS").then(() => {
              setTemplate({
                value: success?.data?.data?.template_id,
                label: newTempName,
              });
            });
            const content = success?.data?.data?.template_content;
            setTemplateContents(content);
            setPreviewContents(content);
            const vars = content.match(/{{\d+}}/g) || [];
            const formatted = vars.map((match) => {
              const number = match.replace(/[{}]/g, "");
              return {
                value: number,
                label: match,
              };
            });
            setTempVars([{ value: "", label: "Select Var" }, ...formatted]);
            setErrors({ ...errors, template: "" });

            setTimeout(() => {
              handleCloseTemplate();
            }, 1000);
          } else if (success?.data?.statusCode > 300) {
            setReason(success?.data?.message || "Upload failed!");
            setVariant("warning");
            setProgress(100);
          }
        })
        .catch((error) => {
          setReason(error?.message || "Upload failed");
          setVariant("warning");
          setProgress(100);
        });
    } else {
      setTempErrors({
        name: !isNameValid,
        classification: !isCategoryValid,
        tempText: !istextValid,
      });
    }

    setValidated(true);
  };

  const fetchTemplateData = (data) => {
    setToastMessage("");
    setToastVariant("");

    const postData = {
      b_party_details: data,
    };
    campaignFileData(postData)
      .then((success) => {
        if (
          success?.data.statusCode >= 200 ||
          success?.data.statusCode <= 204
        ) {
          setTR(success.data.data?.obj?.total_records || 0);
          setVR(success.data.data?.obj?.valid_records || 0);
          setIR(success.data.data?.obj?.duplicate_records || 0);
          setShowPreview(true);
        } else {
          let message = success?.data?.message;
          message = message.replace(/(\d+(\.\d+)?)/g, (match) =>
            parseFloat(match).toFixed(3)
          );
          setToastMessage(message);
          setToastVariant("danger");
          setShowToast(true);

          setShowPreview(false);
        }
      })
      .catch((error) => {
        setToastMessage(error.message || "Upload failed");
        setToastVariant("danger");
        setShowToast(true);
        setShowDefault(false);
        setShowPreview(false);
      });
  };

  const fetchCountries = async () => {
    try {
      const response = await getCountries({ cname: "" });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.countries.map((item) => ({
          value: item.name,
          label: `${item.name} (${item.dialCode})`,
        }));
        setCountryOptions(options);
      } else if (response.data.error) {
        console.error("API returned an error:", response.data.msg);
        setCountryOptions([]);
      }
    } catch (error) {
      setCountryOptions([]);
      console.error("Error fetching country data:", error);
    }
  };

  const fetchSenderOptions = async (usersCountry) => {
    try {
      const response = await SenderList({
        country: usersCountry,
      });
      if (response?.data?.statusCode === 200) {
        const options = response?.data?.data?.items.map((item) => ({
          value: item.id,
          label: item.sender_id,
        }));
        setSenderOptions(options);
      } else {
        console.error("API returned an error:", response.data.message);
        setSenderOptions([]);
      }
    } catch (error) {
      setSenderOptions([]);
      console.error("Error fetching country data:", error);
    }
  };

  // --------------------------------------------------functionality in series------------------------------------------------------------
  const verifyCampaign = (e) => {
    const campaignname = e.target.value;
    setCampaignName(campaignname);

    const regex = /^[a-zA-Z0-9_-]{3,15}$/;

    if (
      campaignname.length >= 3 &&
      campaignname.length <= 50 &&
      regex.test(campaignname)
    ) {
      const postData = { campaign_name: campaignname };
      verify(postData)
        .then((success) => {
          if (
            success?.data?.statusCode >= 200 &&
            success?.data?.statusCode <= 204
          ) {
            setisVerifiedCampaign(true);
            setErrors({ ...errors, campaignName: "" });
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedCampaign(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedCampaign(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedCampaign(false);
    }
  };

  const [campType, setCampType] = useState("WEB");
  const handleTypeChange = (event) => {
    setCampType(event.target.value);
  };

  const [step, setStep] = useState(1);
  // const totalSteps = (campType === "apiPush") ? 2 : 3;
  const totalSteps = 3;

  const fetchRcsAssignedRoutes = async () => {
    try {
      const response = await getRcsAssignedRoutes({
        page: 1,
        limit: 10,
        status: "Active",
        search: "",
        provider: KARIX,
      }).unwrap();
      const routeOptions = response.data.items.map((each) => {
        return {
          label: each.route_name,
          value: each.id
        }
      })
      setRouteOptions(routeOptions || []);
    } catch (error) {
      setRouteOptions([]);
      console.error("Error fetching RCS assigned routes:", error);
    }
  };

  const handleSelection = (event) => {
    const selectedValue = event.currentTarget.value;
    setSelected(selectedValue);
    setErrors({ ...errors, messageType: "" });
    setTemplate("");
    setTemplateList([]);
    setTemplateContent("");
    setPreviewContents("");
    if (selectedValue === "WhatsApp") {
      fetchWabaNum();
      fetchTemplateList(selectedValue);
    } else if (selectedValue === "SMS") {
      fetchCountries();
      fetchRoutes();
    } else if (selectedValue === "RCS") {
      fetchTemplateList(selectedValue);
      fetchRcsAssignedRoutes();
    }
    fetchShortUrls();
  };

  const [smsPe, setSmsPe] = useState("");
  const [header, setHeader] = useState("");
  const [tempType, setTempType] = useState("");
  const [tmId, setTmId] = useState("");

  const [tempVars, setTempVars] = useState([]);
  const [selectedVar, setSelectedVar] = useState();
  const [condVars, setCondVars] = useState([]);

  // Helper function to filter and set template content based on selected id
  const filterTemplateContent = (selected, templateId, type) => {
    // console.log("template type @@@@@@@@@@@@@@@", type, typeof type);

    let matchedTemplate = null;

    if (type === "main") {
        matchedTemplate = templateContent.find(
          (template) => template.template_id === templateId
        );
    } else if (type === "condition") {
      matchedTemplate = templateCondContent.find(
        (template) => template.template_id === templateId
      );
    } else {
      return;
    }

    if (selected === "SMS") {
      if (matchedTemplate) {
        const content = matchedTemplate.template_content;

        const vars = content.match(/{{\d+}}/g) || [];
        const formatted = vars.map((match) => {
          const number = match.replace(/[{}]/g, "");
          return {
            value: number,
            label: match,
          };
        });

        if (type === "main") {
          setTemplateContents(content); // Only for MAIN (in payload)
          setTempVars([{ value: "", label: "Select Var" }, ...formatted]);
          setSmsPe(matchedTemplate?.pe_id || "");
          setHeader(matchedTemplate.header || "");
          setPreviewContents(content);
        } else if (type === "condition") {
          setCondVars([{ value: "", label: "Select Var" }, ...formatted]);
          setPreviewContents2(content);
        }
        setTmId(matchedTemplate.telemarketer_id || "");
      } else {
        setTemplateContents(""); // Clear content if no match is found
      }
    } else if (selected === "WhatsApp") {
      if (matchedTemplate) {
        const content = matchedTemplate.template_components;
        const previewcontent = matchedTemplate.format;

        const vars = content
          .map((comp) => comp.text?.match(/{{\d+}}/g) || [])
          .flat();
        //   console.log("vars", vars)
        const formatted = vars.map((match) => {
          const number = match.replace(/[{}]/g, "");
          return {
            value: number,
            label: match,
          };
        });
        if (type === "main") {
          setTempVars([{ value: "", label: "Select Var" }, ...formatted]);
          setWhatsappTemplateContents(content); // Only for MAIN (in payload)
          setPreviewContents(previewcontent); // PREVIEW content
        } else if (type === "condition") {
          setCondVars([{ value: "", label: "Select Var" }, ...formatted]);
          setPreviewContents2(previewcontent); // PREVIEW content
        }
        setTempType(matchedTemplate.template_type);
        setCategory(matchedTemplate.template_category);
      } else {
        setPreviewContents("");
        setPreviewContents2("");
        setWhatsappTemplateContents([]); // Clear content if no match is found
      }
    } else if (selected === "RCS") {
      if (matchedTemplate) {
        const content = matchedTemplate.content;

        // const vars = content.match(/{{\d+}}/g) || [];
        // const formatted = vars.map((match) => {
        //   const number = match.replace(/[{}]/g, "");
        //   return {
        //     value: number,
        //     label: match,
        //   };
        // });

        if (type === "main") {
          setTemplateContents(content);
          // setTempVars([{ value: "", label: "Select Var" }, ...formatted]);
          setRcsProvider(matchedTemplate.provider)
          setPreviewContents(content);
          setCategory(matchedTemplate.template_type);
        } else if (type === "condition") {
          setPreviewContents2(content); // PREVIEW content
          setRcsProvider(matchedTemplate.provider)
          setPreviewContents(content);
          setCategory(matchedTemplate.template_type);
        }
      }
    }
  };

  // const editContentwithUrl = (url) => {
  // setTemplateContents(prev => (
  //     prev + '\n\n\n\n' + `{$${url}$}`
  // ))
  // }

  // ----------------------functions--------------------------
  const fetchCatgeoriesData = async () => {
    try {
      const response = await CategoriesData({
        country: selectedCountry.value || "",
        user_id: null,
        has_registered_by_super_admin: null,
      });
      if (response?.data) {
        const options = response.data.categories?.map((category) => ({
          value: category,
          label:
            category.charAt(0).toUpperCase() + category.slice(1).toLowerCase(),
        }));
        // Add a default "Select CRM" option at the beginning of the options array
        setCategoryOptions([
          { value: "", label: "Select Category" },
          ...options,
        ]);
      } else {
        setCategoryOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setCategoryOptions([]);
      console.error("Error fetching user data", error);
    }
  };
  useEffect(() => {
    if (selectedCountry) {
      fetchTemplateList("SMS");
      fetchCatgeoriesData();
    }
  }, [selectedCountry]);

  const fetchTemplateList = async (value, searchKey = "") => {
    const userId = JSON.parse(
      localStorage.getItem("TOKEN")
    ).associated_enterprise_id;
    if (value === "SMS") {
      await getSMSTemplateList({
        user_id: userId,
        search: searchKey, // Pass the search key here
        status: "Active",
        country: selectedCountry?.value,
      })
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            const options = response?.data?.data?.result?.data.map((user) => ({
              value: user.template_id,
              label: user.template_name,
            }));
            setTemplateList(options);
            setTemplateContent(response?.data?.data?.result?.data);
          } else {
            setTemplateList([]);
          }
        })
        .catch((error) => {
          setTemplateList([]);
        });
    } else if (value === "WhatsApp") {
      await getWhatsappTemplateList({
        user_id: userId,
        page: "",
        limit: "",
        search: searchKey,
        fromDate: "",
        toDate: "",
        list_type: "",
        status: "APPROVED",
      })
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            const options = response.data.data.result.data.map((user) => ({
              value: user.template_id,
              label: user.template_name,
            }));
            setTemplateList(options);
            setTemplateContent(response?.data?.data?.result?.data);
          } else {
            setTemplateList([]);
          }
        })
        .catch((error) => {
          setTemplateList([]);
        });
    } else if (value === "RCS") {
          await getRegisteredRcsTemplates({
            page: 1,
            limit: 10,
            status: "approved",
            userId: "",
            search: "",
            templateType: "",
            provider: KARIX,
          }).then((response) => {
            if (response?.data?.statusCode === 200) {
              const options = response.data.data.items.map((template) => ({
                value: template.template_id,
                label: template.template_name,
              }));
              setTemplateList(options);
              setTemplateContent(response?.data?.data?.items);
            } else {
              setTemplateList([]);
            }
          })
          .catch((error) => {
            setTemplateList([]);
          });
      };
  };

  const [fetchedWaba, setFetchedWaba] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState();

  const [getWaba] = useWabaForEuMutation();
  const fetchWabaNum = () => {
    getWaba({ user_id: enterprise_id })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const options = response?.data?.data.map((data) => ({
            label: data.mobile,
            value: data.mobile,
          }));
          setFetchedWaba(options);
        } else {
          setFetchedWaba([]);
        }
      })
      .catch((error) => {
        setFetchedWaba([]);
      });
  };

  const [getRoutes] = useRoutesOfEAForEUMutation();
  const [routeOptions, setRouteOptions] = useState([]);
  const [allRoutes, setAllRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState();

  const fetchRoutes = async () => {
    getRoutes({ user_id: enterprise_id })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const options = response?.data?.data?.result?.data.map((data) => ({
            label: data.route_name,
            value: data.id,
          }));
          setRouteOptions(options || []);
          setAllRoutes(response?.data?.data?.result?.data);
        } else {
          setRouteOptions([]);
        }
      })
      .catch((error) => {
        console.log("Error fetching user data in routes", error);
        setRouteOptions([]);
      });
  };

  const [systemId, setSystemId] = useState("");
  const getSystemId = (id) => {
    const findObj = allRoutes.find((route) => route.id === id);
    const foundId = findObj.system_id || "";
    setSystemId(foundId);
  };

  const [getShortUrls] = useGetShortUrlsMutation();
  const [shortUrlList, setShortUrlList] = useState([]);
  const [selectedUrl, setSelectedUrl] = useState();

  const fetchShortUrls = async () => {
    getShortUrls({ user_id: userOwnId })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const options = response?.data?.data?.result?.data.map((user) => ({
            value: user.id,
            label: user.url_name,
          }));
          setShortUrlList([{ value: "", label: "Select URL" }, ...options]);
        } else {
          setShortUrlList([]);
        }
      })
      .catch((error) => {
        console.log("Error fetching user data in routes", error);
        setShortUrlList([]);
      });
  };

  const fetchTemplateListCondition = async (value, searchKey, index) => {
    const userId = JSON.parse(localStorage.getItem("user")).id;
    let options = [];

    if (value === "SMS") {
      try {
        const response = await getSMSTemplateList({
          user_id: userId,
          page: "",
          limit: "20",
          search: searchKey,
          fromDate: "",
          toDate: "",
          list_type: "",
          status: "Active",
        });
        if (response?.data?.statusCode === 200) {
          options = response.data.data.result.data.map((user) => ({
            value: user.template_id,
            label: user.template_name,
          }));
          setTemplateCondContent(response.data.data.result.data);
        }
      } catch (error) {
        alert("Error fetching SMS templates", error);
      }
    } else if (value === "WhatsApp") {
      try {
        const response = await getWhatsappTemplateList({
          user_id: userId,
          page: "",
          limit: "20",
          search: searchKey,
          fromDate: "",
          toDate: "",
          list_type: "",
          status: "APPROVED",
        });
        if (response?.data?.statusCode === 200) {
          options = response.data.data.result.data.map((user) => ({
            value: user.template_id,
            label: user.template_name,
          }));
          setTemplateCondContent(response.data.data.result.data);
        }
      } catch (error) {
        alert("Error fetching WhatsApp templates", error);
      }
    }  else if (value === "RCS") {
      await getRegisteredRcsTemplates({
        page: 1,
        limit: 10,
        status: "approved",
        userId: "",
        search: "",
        templateType: "",
        provider: KARIX,
      }).then((response) => {
        if (response?.data?.statusCode === 200) {
          options = response.data.data.items.map((template) => ({
            value: template.template_id,
            label: template.template_name,
          }));
          setTemplateCondContent(response?.data?.data?.items);
        }
      })
      .catch((error) => {
        alert("Error fetching WhatsApp templates", error);
      });
  };

    // Update the templateLists at the specified index
    setTemplateLists((prev) => {
      const updatedLists = [...prev];
      updatedLists[index] = options; // Update the specific index with fetched options
      return updatedLists;
    });
  };

  const [tracking, setTracking] = useState(true);

  // Fetch campaign list based on the search string
  const fetchCampaignList = async (searchKey = "") => {
    const userId = JSON.parse(localStorage.getItem("user")).id;
    getContactList({
      user_id: userId,
      page: "",
      limit: "20",
      search: searchKey, // Pass the search key here
      fromDate: "",
      toDate: "",
      list_type: dataType,
    })
      .then((response) => {
        if (response?.data?.data?.response?.statusCode === 200) {
          const options = response?.data?.data?.response?.data.map((user) => ({
            value: user.id,
            label: user.list_name,
          }));
          setContactList(options);
        } else {
          alert("Failed to fetch user data");
        }
      })
      .catch((error) => {
        alert("Error fetching user data", error);
      });
  };

  const handleConditionChange = (index, field, value) => {
    const updatedConditions = [...conditions];
    updatedConditions[index][field] = value;

    // Clear message if the selected value is empty
    if (field === "message" && value === "") {
      updatedConditions[index].message = ""; // Clear the message
    }

    // Fetch templates when message type changes
    if (field === "message") {
      setPreviewContents2("");
      fetchTemplateListCondition(value, "", index); // Call the API with correct parameters
    }

    if (field === "message" && value === "WhatsApp") {
      fetchWabaNum();
    } else if (field === "message" && value === "SMS") {
      fetchRoutes();
    } else if (field === "message" && value === "RCS") {
        fetchRcsAssignedRoutes();
    }

    // If changing the type of the first condition to "Success", force the second condition to be "Failure" if it exists
    if (
      field === "type" &&
      value === "Success" &&
      index === 0 &&
      conditions.length > 1
    ) {
      updatedConditions[1].type = "Failure";
    }

    // If changing the first condition's type to "Failure", remove the second condition
    if (field === "type" && value === "Failure" && index === 0) {
      if (conditions.length > 1) {
        updatedConditions.splice(1, 1); // Remove the second condition
      }
    }

    setConditions(updatedConditions);
  };

  // Handler to add a new condition (only if there are fewer than 2 conditions and if the first condition is not "Failure")
  const addCondition = () => {
    if (
      conditions[0]?.type !== "Success" &&
      conditions[0]?.type !== "Failure"
    ) {
      setConditions([
        {
          id: 1,
          type: "",
          message: "",
          template: "",
        },
      ]);
      setShowCondition(true);
      return;
    }
    // Prevent adding a new condition if the first condition is "Failure"
    if (conditions.length === 1 && conditions[0].type === "Failure") {
      setErrors({
        ...errors,
        conditions: "Cannot add another condition after a failure condition.",
      });
      return; // Do nothing if the first condition is "Failure"
    }

    if (conditions.length < 2) {
      const newConditions = [...conditions];
      newConditions.push({
        id: conditions.length + 1,
        type: "",
        message: "",
        template: "",
      });
      setConditions(newConditions);
      setErrors({ ...errors, conditions: "" });
    }
  };

  // Handler to delete a condition and re-index IDs
  const deleteCondition = (index) => {
    const updatedConditions = conditions.filter((_, i) => i !== index);

    // Reindex conditions to maintain sequential IDs starting from 1
    const reindexedConditions = updatedConditions.map((condition, i) => ({
      ...condition,
      id: i + 1,
    }));

    if (reindexedConditions.length === 0) {
      setShowCondition(false);
    }
    setConditions(reindexedConditions);
    setErrors({ ...errors, conditions: "" });
  };

  const handleContactForm = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setContactForm({
        ...contactForm,
        file: files[0],
      });
    } else {
      setContactForm({
        ...contactForm,
        [name]: value,
      });
    }
  };

  const handleClose = () => {
    setShowDefault(false);
    setShowPreview(false);
  };

  const handlePreview = (e) => {
    e.preventDefault();

    // Initialize validation errors
    let validationErrors = {
      scheduling: "",
      startDate: "",
      endDate: "",
      startTime: "",
      activePeriod: "",
      selectedWeekdays: "",
      selectedDays: "",
    };

    if (dataType !== "apiPush") {
      if (!scheduling) {
        validationErrors.scheduling =
          "Please select a scheduling option (One-Time or Recurring)";
      }

      if (scheduling === "Recurring") {
        // Validate required dates and time
        if (!startDate || !endDate || !startTime) {
          if (!startDate) {
            validationErrors.startDate = "Start Date is required";
          }
          if (!endDate) {
            validationErrors.endDate = "End Date is required";
          }
          if (!startTime) {
            validationErrors.startTime = "Start Time is required";
          }
        }

        // Validate date order
        if (endDate && startDate && endDate.isBefore(startDate)) {
          validationErrors.endDate =
            "End date cannot be earlier than Start date.";
        }

        // Validate active period
        if (!activePeriod) {
          validationErrors.activePeriod =
            "Please select an active period (Weekly or Monthly)";
        }

        // Validate weekly selection
        if (activePeriod === "Weekly" && selectedWeekdays.length === 0) {
          validationErrors.selectedWeekdays =
            "Please select a day for the weekly frequency";
        }

        // Validate monthly selection
        if (activePeriod === "Monthly" && selectedDays.length === 0) {
          validationErrors.selectedDays =
            "Please select a frequency for the monthly schedule";
        }
      } else {
        if (!startDate || !startTime) {
          if (!startDate) {
            validationErrors.startDate = "Start Date is required";
          }
          if (!startTime) {
            validationErrors.startTime = "Start Time is required";
          }
        }
      }
    } else {
      setScheduling("");
      setStartDate(null);
      setShowDefault(true);
    }

    // Log validation errors

    // If any validation fails, set errors and stop preview
    if (Object.values(validationErrors).some((error) => error !== "")) {
      setErrors(validationErrors);
    } else {
      // If no errors, proceed with preview
      setShowDefault(true);
      setErrors(validationErrors); // Clear errors
    }
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setToastMessage("");
    setToastVariant("");

    const content =
      ["SMS","RCS"].includes(selected)
        ? templateContents
        : selected === "WhatsApp"
        ? { components: whatsappTemplateContents }
        : "";

    const formData = new FormData();
    formData.append("campaign_name", campaignName);
    formData.append("campaign_start", moment(startDate).format("YYYY-MM-DD"));
    formData.append("campaign_run_time", startTime.format("HH:mm") || "");
    formData.append(
      "campaign_end",
      scheduling === "OneTime"
        ? ""
        : dataType === "apiPush"
        ? ""
        : moment(endDate).isValid()
        ? moment(endDate).startOf("day").format("YYYY-MM-DD")
        : ""
    );
    formData.append(
      "template_id",
      ["SMS", "RCS"].includes(selected)
        ? template?.value
        : selected === "WhatsApp"
        ? template?.label
        : ""
    );
    formData.append("template_content", JSON.stringify(content));
    {
      (selected === "WhatsApp" ||
        conditions[0]?.message === "WhatsApp" ||
        conditions[1]?.message === "WhatsApp") &&
        formData.append("template_type", tempType);
    }
    {
      (selected === "SMS" ||
        conditions[0]?.message === "SMS" ||
        conditions[1]?.message === "SMS") &&
        formData.append("telemarketer_id", tmId);
    }
    formData.append("contact_mode", dataType);
    formData.append(
      "b_party_details",
      dataType === "addressbook"
        ? contact.label
        : dataType === "api"
        ? api.label
        : ""
    ); //If contact_mode is addressbook & API
    formData.append("schedule", scheduling);
    formData.append(
      "recurring_frequency",
      scheduling === "OneTime" ? "" : dataType === "apiPush" ? "" : activePeriod
    );
    formData.append(
      "recurring_day",
      scheduling === "OneTime" ? "" : selectedWeekdays
    );
    formData.append(
      "recurring_date",
      scheduling === "OneTime" ? "" : selectedDays
    );
    formData.append("file", contactForm.file);
    formData.append("campaign_type", selected);
    {
      showCondition &&
        formData.append("campaign_details", JSON.stringify(conditions));
    } //Not in API
    formData.append("waba_mobile", selectedNumber?.value || "");
    formData.append("tracking_url", tracking);
    formData.append(
      "variable_mapping",
      JSON.stringify({
        key: `${selectedVar?.value || ""}`,
        value: `${selectedUrl?.label || ""}`,
      })
    );

    formData.append("header", header);
    formData.append("pe_id", smsPe);
    formData.append("priority", "low");
    formData.append("account", systemId);
    formData.append("userchain", userObject.user_chain);
    {
      selected === "SMS" && formData.append("country", selectedCountry.value);
    }
    {
      internationalSms && formData.append("sender_id", senderID.label);
    }

    //  formData.forEach((value, key) => {
    //       console.log(`${key}:`, value);
    //     });

    // formData.append('listname', contactForm.file);//If contact_mode is File - NOT IN API {Not included}
    // formData.append('remarks', contactForm.file);//If contact_mode is File - NOT IN API {Not included}
    // formData.append('shortName', contactForm.file);//Not in API {Not included}
    // formData.append('domain', contactForm.file);//If contact_mode is API Push - NOT IN API {Not included}
    // formData.append('whatsapp_bulk_file', whatsappBulkFile);

    uploadList(formData)
      .then((success) => {
        if (
          success?.data?.statusCode >= 200 &&
          success?.data?.statusCode <= 204
        ) {
          setToastMessage(success?.data?.message);
          setToastVariant("success");
          setShowDefault(false);

          setCampaignName("");
          setSelected("");
          setDataType("");
          setTemplate("");
          setFetchedWaba([]);
          setSelectedNumber("");
          setRouteOptions([]);
          setSelectedRoute("");
          setContact();
          setApi("");
          setContactForm({
            file: "",
          });
          setTemplate();
          setConditions([{ id: 1, type: "", message: "", template: "" }]);
          setScheduling("OneTime");
          setStartDate(null);
          setEndDate(moment());
          setActivePeriod("Weekly");
          setSelectedWeekdays([]);
          setSelectedDays([]);
          setStartTime(null);
          setPreviewContents("");
          setPreviewContents2("");
          setWhatsappTemplateContents([]);

          setStep(1);
          history.push(Routes.Campaign.path);
        } else {
          setToastMessage(success?.data?.message);
          setToastVariant("danger");
          setShowDefault(false);
        }
        setShowToast(true);
        setShowDefault(false);
      })
      .catch((error) => {
        setToastMessage(error.message || "Upload failed");
        setToastVariant("danger");
        setShowToast(true);
        setShowDefault(false);
      });
  };

  const handleNext = () => {
    setToastMessage("");
    setToastVariant("");
    if (step === 1) {
      if (validateStep1()) {
        setStep(step + 1);
        setToastMessage("");
        setToastVariant("");
      } else {
        setToastMessage("Please fill in all required fields for Step 1.");
        setToastVariant("danger");
        setShowToast(true);
      }
    } else if (step === 2) {
      if (validateStep2()) {
        setStep(step + 1);
        setToastMessage("");
        setToastVariant("");
      } else {
        setToastMessage("Please fill in all required fields for Step 2.");
        setToastVariant("danger");
        setShowToast(true);
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth", // or 'auto' if you want instant scroll
    });

    // console.log("templateContents",templateContents)
  };

  const validateStep1 = () => {
    let valid = true;
    let newErrors = { ...errors };
    // Validate Campaign Name
    if (!campaignName || !/^[a-z0-9_]{3,}$/.test(campaignName)) {
      newErrors.campaignName =
      "Campaign name must be lowercase, alphanumeric, at least 3 words, and only _ or - allowed.";
      valid = false;
    } else {
      newErrors.campaignName = "";
    }

    // Validate Message Type
    if (!selected) {
      newErrors.messageType = "Please select a message type.";
      valid = false;
    } else {
      newErrors.messageType = "";
    }

    // Validate Country
    if (selected === "SMS" && !selectedCountry) {
      newErrors.country = "Please select country.";
      valid = false;
    } else {
      newErrors.country = "";
    }

    // Validate SenderID
    if (internationalSms && !senderID) {
      newErrors.sender = "Please select Sender ID.";
      valid = false;
    } else {
      newErrors.sender = "";
    }

    // Validate Data Type
    if (!template) {
      newErrors.template = "Please select a template.";
      valid = false;
    } else {
      newErrors.template = "";
    }

    // Validate WABA or ROUTE
    if (selected === "WhatsApp" && !selectedNumber) {
      newErrors.waba = "Please select a WABA Number.";
      valid = false;
    } else {
      newErrors.waba = "";
    }
    if (
      (selected === "SMS" && !selectedRoute) ||
      (selected === "" && !selectedRoute)
    ) {
      newErrors.route = "Please select a Route.";
      valid = false;
    } else {
      newErrors.route = "";
    }

    if (
      (selectedVar === "" && selectedUrl !== "") ||
      (selectedUrl === "" && selectedVar !== "")
    ) {
      newErrors.shortUrl = "Please select a variable along with its ShortUrl.";
      valid = false;
    } else {
      newErrors.shortUrl = "";
    }

    setErrors(newErrors);
    return valid;
  };

  const validateStep2 = () => {
    let valid = true;
    let newErrors = { ...errors };

    // Validate Conditions
    if (!showCondition) {
      newErrors.conditions = "";
    } else if (conditions.length === 1) {
      if (
        !conditions[0].type ||
        !conditions[0].message ||
        !conditions[0].template ||
        (conditions[0].message === "WhatsApp" && !conditions[0].waba) ||
        (conditions[0].message === "SMS" && !conditions[0].route)
      ) {
        newErrors.conditions = "Please complete the Condition-1.";
        valid = false;
      } else {
        newErrors.conditions = "";
      }
    } else if (conditions.length === 2) {
      if (
        !conditions[1].type ||
        !conditions[1].message ||
        !conditions[1].template ||
        (conditions[1].message === "WhatsApp" && !conditions[0].waba) ||
        (conditions[1].message === "SMS" && !conditions[0].route)
      ) {
        newErrors.conditions = "Please complete the Condition-2.";
        valid = false;
      } else {
        newErrors.conditions = "";
      }
    }

    // Validate DataType
    if (!dataType) {
      newErrors.dataType = "Please select a data type.";
      valid = false;
    } else {
      newErrors.dataType = "";
    }

    if (dataType === "addressbook" && !contact) {
      newErrors.contact = "Please select from ContactList.";
      valid = false;
    } else {
      newErrors.contact = "";
    }

    if (dataType === "api" && !api) {
      newErrors.api = "Please select from API-Lists.";
      valid = false;
    } else {
      newErrors.api = "";
    }

    if (dataType === "file" && !contactForm.file) {
      newErrors.file = "Please select a File.";
      valid = false;
    } else {
      newErrors.file = "";
    }

    setErrors(newErrors);
    return valid;
  };

  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
  };

  // const handleEndTimeChange = (time) => {
  //   setEndTime(time);
  // };

  // const handleSmsChange = (text) => {
  //     setTemplateContents(text); // Sync SmsCalculator message with template contents
  // };

  // const toggleEmojiPicker = () => {
  //     setShowEmojiPicker((prev) => !prev);
  // };
  // const handleEmojiClick = (emojiData) => {
  //     const emoji = emojiData.emoji; // Get the emoji character
  //     setTemplateContents((prevContents) => prevContents + emoji); // Append the emoji to the current content
  // };

  // Effect to handle clicks outside the emoji picker
  // useEffect(() => {
  //     const handleClickOutside = (event) => {
  //         if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
  //             setShowEmojiPicker(false); // Close emoji picker if clicked outside
  //         }
  //     };

  //     document.addEventListener('mousedown', handleClickOutside);
  //     return () => {
  //         document.removeEventListener('mousedown', handleClickOutside);
  //     };
  // }, []);

  const handleCalculation = ({
    textLength,
    remaining,
    numberOfSMS,
    encoding,
  }) => {
    setSmsDetails({ textLength, remaining, numberOfSMS, encoding });
  };

  // template create
  // Toggle the emoji picker visibility
  const toggleEmojiPicker = () => {
    setShowEmojiPicker((prev) => !prev);
  };

  const handleChange = (e) => {
    setNewTemplateText(e.target.value);
  };

  // Append emoji to the message field in form state
  const handleEmojiClick = (emojiData) => {
    const emoji = emojiData.emoji; // Get the emoji character
    setNewTemplateText((prev) => (prev || "") + emoji);
  };

  const AddAuthVars = () => {
    const textarea = textareaRef.current;

    const varToAdd = `{{${count}}}`;

    // Get the cursor position
    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;

    // Get current textarea content (which could be empty)
    const currentContent = newTemplatetext || ""; // Handle empty string case

    // Insert the variable at the cursor position
    const updatedValue =
      currentContent.substring(0, startPos) + // Everything before the cursor
      varToAdd + // The variable to insert
      currentContent.substring(endPos); // Everything after the cursor

    // Update the state with the new value
    setNewTemplateText(updatedValue);

    // Maintain the cursor position after insertion
    setTimeout(() => {
      textarea.selectionStart = textarea.selectionEnd =
        startPos + varToAdd.length;
      textarea.focus();
    }, 0);

    setCount((prevCount) => prevCount + 1);
  };

  // --------mobile preview---------------
  useEffect(() => {
    previewMobileScreens();
  }, [step]);

  const previewMobileScreens = () => {
    if (step >= 2 && showCondition && conditions[0].template)
      return (
        <MobilePreviews
          currentChannel={conditions[0].message} //<--------change this when RCS works
          content={previewContents2}
          onContentChange={(newContent) => setTemplateContents(newContent)}
          smsHeader={header}
          waCategory={category}
          rcsProvider={rcsProvider}
        />
      );
    else if (step >= 1)
      return (
        <MobilePreviews
          currentChannel={selected}
          content={previewContents}
          onContentChange={(newContent) => setTemplateContents(newContent)}
          smsHeader={header}
          waCategory={category}
          rcsProvider={rcsProvider}
        />
      );
  };

  const templateSearchTimeoutRef = useRef(null);
  const contactSearchTimeoutRef = useRef(null);

  return (
    <div>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div style={{ margin: "12px" }}>
        {/* Step Indicator */}
        <ProgressSteps step={step} totalSteps={totalSteps} />

        {/* Step content */}
        <div className="d-flex flex-nowrap w-100 gap-3">
        <div className="w-75 mid-section-scroll" style={{maxHeight: '80vh'}}>
            <Card
              border="1"
              className="m-0"
              style={{ minHeight: "400px", maxHeight: "max-content" }}
            >
                <Form>
                  <div className="step-content">
                    {step === 1 && (
                      <div>
                        <Form.Group as={Col} xs={12} md={6} className="mb-3">
                          <Form.Label>Campaign Name</Form.Label>
                          <InputGroup>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter Campaign Name"
                              value={campaignName}
                              onChange={verifyCampaign}
                              // pattern="^[a-z0-9_-]{3,15}$"
                              title="Campaign name must be lowercase, alphanumeric, at least 3 words, and only _ or - allowed."
                              maxLength={15}
                              minLength={3}
                            />
                            {isVerifiedCampaign && (
                              <InputGroup.Text>
                                <CheckIcon
                                  width={20}
                                  className="text-success"
                                />
                              </InputGroup.Text>
                            )}
                            {isVerifiedCampaign === false && (
                              <InputGroup.Text>
                                <XCircleIcon
                                  width={20}
                                  className="text-danger"
                                />
                              </InputGroup.Text>
                            )}
                          </InputGroup>
                          {errors.campaignName && (
                            <Form.Text className="text-danger">
                              {errors.campaignName}
                            </Form.Text>
                          )}
                        </Form.Group>
                        <Form.Group as={Col} className="mb-3">
                          <Form.Label>Campaign Type</Form.Label>
                          <div className="d-flex flex-wrap justify-content-start">
                            {/* <Form.Check
                            type="radio"
                            id="apiPush"
                            label="API Push"
                            name="campaignTypeOptions"
                            value="apiPush"
                            className="me-3"
                            onChange={handleTypeChange}
                            checked={campType === "apiPush"}
                          /> */}
                            <Form.Check
                              type="radio"
                              id="web"
                              label="WEB"
                              name="campaignTypeOptions"
                              value="WEB"
                              className="me-3"
                              onChange={handleTypeChange}
                              checked={campType === "WEB"}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} className="mb-3">
                          <Form.Label>Select Message Type</Form.Label>
                          <div className="d-flex flex-wrap">
                            <Button
                              variant={
                                selected === "SMS" ? "gray-800" : "white"
                              }
                              className="d-grid me-3"
                              onClick={handleSelection}
                              value={"SMS"}
                            >
                              <AiFillMessage className="mb-2 icon-clg text-gray-400" />{" "}
                              SMS
                            </Button>
                            <Button
                              variant={
                                selected === "WhatsApp" ? "gray-800" : "white"
                              }
                              className="d-grid me-3"
                              onClick={handleSelection}
                              value={"WhatsApp"}
                            >
                              <IoLogoWhatsapp className="mb-2 icon-clg text-gray-400" />
                              WhatsApp
                            </Button>
                            <Button 
                              variant={selected === 'RCS' ? "gray-800" : "white"}
                              className="d-grid" 
                              onClick={handleSelection} 
                              value={'RCS'}
                            >
                              <BiSolidMessageSquareDetail className="mb-2 icon-clg text-gray-400" />RCS
                            </Button>
                          </div>
                          {errors.messageType && (
                            <Form.Text className="text-danger">
                              {errors.messageType}
                            </Form.Text>
                          )}
                        </Form.Group>
                        {selected === "SMS" && (
                          <Form.Group as={Col} xs={12} className="mb-3">
                            <Form.Label>Country</Form.Label>
                            <Select
                              options={countryOptions}
                              placeholder={"Select Country"}
                              className="mb-0"
                              value={selectedCountry}
                              onChange={(selectedOption) => {
                                handleCountry(selectedOption);
                              }}
                            />
                            {errors.country && (
                              <Form.Text className="text-danger">
                                {errors.country}
                              </Form.Text>
                            )}
                          </Form.Group>
                        )}
                        {internationalSms && (
                          <Form.Group as={Col} xs={12} className="mb-3">
                            <Form.Label>Sender ID</Form.Label>
                            <Select
                              options={senderOptions}
                              placeholder={"Select Sender ID"}
                              className="mb-0"
                              value={senderID}
                              onChange={(selectedOption) => {
                                setSenderID(selectedOption);
                                setHeader(selectedOption.label);
                              }}
                            />
                            {errors.sender && (
                              <Form.Text className="text-danger">
                                {errors.sender}
                              </Form.Text>
                            )}
                          </Form.Group>
                        )}
                        <Form.Group as={Col} xs={12} className="mb-3">
                          <Form.Label>Template</Form.Label>
                          <div className="d-flex">
                            <Form.Group
                              as={Col}
                              xs={internationalSms ? 6 : 12}
                              md={internationalSms ? 9 : 12}
                            >
                              <Select
                                options={templateList}
                                placeholder={"Select Template"}
                                className="mb-0"
                                value={template}
                                onChange={(selectedOption) => {
                                  setTemplate(selectedOption);
                                  setErrors({ ...errors, template: "" });
                                  if (selectedOption?.value) {
                                    filterTemplateContent(
                                      selected,
                                      selectedOption.value,
                                      "main"
                                    );
                                  }
                                }}
                                onMenuClose={() => fetchTemplateList(selected, "")}
                                onInputChange={(inputValue, { action }) => {
                                  if (action === "input-change") {
                                    if (templateSearchTimeoutRef.current) {
                                      clearTimeout(templateSearchTimeoutRef.current);
                                    }
                                    templateSearchTimeoutRef.current = setTimeout(() => {
                                      fetchTemplateList(selected, inputValue || "");
                                    }, 300);
                                  }
                                }}
                                isSearchable
                                isClearable
                              />
                            </Form.Group>
                            {internationalSms && (
                              <Form.Group
                                as={Col}
                                xs={6}
                                md={3}
                                className="ms-2"
                              >
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  className="ms-auto d-inline-flex align-items-center"
                                  onClick={() => {
                                    setTemplateModal(true);
                                  }}
                                >
                                  <PlusIcon className="icon icon-xs me-2" />
                                  New Template
                                </Button>
                              </Form.Group>
                            )}
                          </div>
                          {errors.template && (
                            <Form.Text className="text-danger">
                              {errors.template}
                            </Form.Text>
                          )}
                        </Form.Group>

                        {selected === "WhatsApp" ? (
                          <Form.Group as={Col} xs={12} className="mb-3">
                            <Form.Label>WABA Number</Form.Label>
                            <Select
                              options={fetchedWaba}
                              placeholder={"Select Number"}
                              className="mb-0"
                              value={selectedNumber}
                              onChange={(selectedOption) => {
                                setSelectedNumber(selectedOption);
                                setErrors({ ...errors, waba: "" });
                              }}
                            />
                            {errors.waba && (
                              <Form.Text className="text-danger">
                                {errors.waba}
                              </Form.Text>
                            )}
                          </Form.Group>
                        ) : (
                          <Form.Group as={Col} xs={12} className="mb-3">
                            <Form.Label>Route</Form.Label>
                            <Select
                              options={routeOptions}
                              placeholder={"Select Routes"}
                              className="mb-0"
                              value={selectedRoute}
                              onChange={(selectedOption) => {
                                setSelectedRoute(selectedOption);
                                setErrors({ ...errors, route: "" });
                                if(selected === "SMS") getSystemId(selectedOption.value);
                              }}
                            />
                            {errors.route && (
                              <Form.Text className="text-danger">
                                {errors.route}
                              </Form.Text>
                            )}
                          </Form.Group>
                        )}

                        <Form.Group as={Col} xs={12} className="mb-3">
                          <div className="d-flex">
                            <Form.Group as={Col} xs={3} md={3}>
                              <Form.Label>Variable</Form.Label>
                              <Select
                                options={tempVars}
                                // isMulti
                                placeholder={"-Variable-"}
                                className="mb-0"
                                value={selectedVar}
                                onChange={(selectedOption) => {
                                  setSelectedVar(selectedOption);
                                }}
                              />
                            </Form.Group>
                            <Form.Group as={Col} xs={9} md={9} className="ms-2">
                              <Form.Label>Short URL</Form.Label>
                              <Select
                                options={shortUrlList}
                                placeholder={"Select ShortUrl"}
                                className="mb-0"
                                value={selectedUrl}
                                onChange={(selectedOption) => {
                                  setSelectedUrl(selectedOption);
                                }}
                              />
                            </Form.Group>
                          </div>
                          {errors.shortUrl && (
                            <Form.Text className="text-danger">
                              {errors.shortUrl}
                            </Form.Text>
                          )}
                        </Form.Group>

                        <Form.Group as={Col} xs={12} className="mb-3">
                          <FormCheck type="switch" className="mt-2">
                            <FormCheck.Input
                              type="checkbox"
                              id="trackSwitch"
                              checked={tracking}
                              onChange={() => setTracking(!tracking)}
                            />
                            <FormCheck.Label
                              htmlFor="trackSwitch"
                              style={{ marginLeft: "8px" }}
                            >
                              Tracking URL
                            </FormCheck.Label>
                          </FormCheck>
                        </Form.Group>

                       {tracking && <p className="m-0">
                          <b>
                            Now each user from addressbook/apilist/fileupload
                            will get unique URLs.
                          </b>
                        </p>}
                      </div>
                    )}
                    {step === 2 && (
                      <div>
                        <Row className="mb-3">
                          {/* Add Condition Button */}
                          <Form.Group as={Col} xs={12} className="mb-2">
                            <div className="d-flex align-items-end mb-3">
                              <Form.Label>Conditions</Form.Label>
                              <Button
                                onClick={addCondition}
                                className="ms-auto rounded-pill"
                                // style={{
                                //   cursor: 'pointer'
                                // }}
                                variant="secondary"
                              >
                                {conditions[0]?.type === "Failure" &&
                                conditions.length === 1
                                  ? `Condition 1/1`
                                  : conditions[0]?.type !== "Success" &&
                                    conditions[0]?.type !== "Failure"
                                  ? `Add Condition`
                                  : `+ Condition ${conditions.length}/2`}
                              </Button>
                            </div>

                            {showCondition &&
                              conditions.map((condition, index) => (
                                <Row
                                  key={index}
                                  className="border-bottom py-3 mb-5"
                                >
                                  <div
                                    className="d-flex align-items-center mb-3"
                                    key={condition.id}
                                  >
                                    {/* Condition Type */}
                                    <Form.Select
                                      onChange={(e) => {
                                        handleConditionChange(
                                          index,
                                          "type",
                                          e.target.value
                                        );
                                        setErrors({
                                          ...errors,
                                          conditions: "",
                                        });
                                      }}
                                      value={condition.type}
                                    >
                                      <option value="">
                                        Select Condition
                                      </option>
                                      {/* Only include "Success" if it's not already chosen in the first condition */}
                                      {!(
                                        index === 1 &&
                                        conditions[0]?.type === "Success"
                                      ) && (
                                        <option value="Success">Success</option>
                                      )}
                                      <option value="Failure">Failure</option>
                                    </Form.Select>

                                    {/* Message Type */}
                                    <Form.Select
                                      className="ms-2"
                                      onChange={(e) => {
                                        handleConditionChange(
                                          index,
                                          "message",
                                          e.target.value
                                        );
                                        setErrors({
                                          ...errors,
                                          conditions: "",
                                        });
                                      }}
                                      value={condition.message}
                                    >
                                      <option value="">
                                        Select Message Type
                                      </option>

                                      {/* First condition options */}
                                      {/* {index === 0 && (
                                                                    <> */}
                                      {selected === "SMS" && (
                                        <>
                                          <option value="WhatsApp">
                                            WhatsApp
                                          </option>
                                          <option value="RCS">RCS</option>
                                        </>
                                      )}
                                      {selected === "WhatsApp" && (
                                        <>
                                          <option value="SMS">SMS</option>
                                          <option value="RCS">RCS</option>
                                        </>
                                      )}
                                      {selected === "RCS" && (
                                        <>
                                          <option value="WhatsApp">
                                            WhatsApp
                                          </option>
                                          <option value="SMS">SMS</option>
                                        </>
                                      )}
                                      {/* </>
                                                                )} */}

                                      {/* Second condition options */}
                                      {/* {index === 1 && (
                                                                    <>
                                                                        {conditions[0]?.message === 'SMS' && selected === 'WhatsApp' && (
                                                                            <option value="RCS">RCS</option>
                                                                        )}
                                                                        {conditions[0]?.message === 'SMS' && selected === 'RCS' && (
                                                                            <option value="WhatsApp">WhatsApp</option>
                                                                        )}


                                                                        {conditions[0]?.message === 'WhatsApp' && selected === 'SMS' && (
                                                                            <option value="RCS">RCS</option>
                                                                        )}
                                                                        {conditions[0]?.message === 'WhatsApp' && selected === 'RCS' && (
                                                                            <option value="SMS">SMS</option>
                                                                        )}


                                                                        {conditions[0]?.message === 'RCS' && selected === 'SMS' && (

                                                                            <option value="WhatsApp">WhatsApp</option>

                                                                        )}
                                                                        {conditions[0]?.message === 'RCS' && selected === 'WhatsApp' && (

                                                                            <option value="SMS">SMS</option>

                                                                        )}
                                                                    </>
                                                                )} */}
                                    </Form.Select>

                                    <Form.Select
                                      className="ms-2"
                                      onChange={(e) => {
                                        handleConditionChange(
                                          index,
                                          "template",
                                          e.target.value
                                        );
                                        filterTemplateContent(
                                          condition.message,
                                          e.target.value,
                                          "condition"
                                        );
                                        setErrors({
                                          ...errors,
                                          conditions: "",
                                        });
                                      }}
                                      value={condition.template}
                                    >
                                      <option value="">
                                        Select {condition.message} Template
                                      </option>
                                      {templateLists[index]?.map((template) => (
                                        <option
                                          key={template.value}
                                          value={template.value}
                                        >
                                          {template.label}
                                        </option>
                                      ))}
                                    </Form.Select>

                                    {/* Delete Button */}
                                    {conditions.length >= 1 && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip className="m-0">
                                            Delete
                                          </Tooltip>
                                        }
                                      >
                                        <Card.Link
                                          className="ms-2"
                                          onClick={() => deleteCondition(index)}
                                        >
                                          <RiDeleteBin6Line
                                            size={20}
                                            className="mb-1 icon icon-xs text-danger"
                                          />
                                        </Card.Link>
                                      </OverlayTrigger>
                                    )}
                                  </div>

                                  {condition.message === "WhatsApp" ? (
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      className="mb-4"
                                    >
                                      <Form.Label>WABA Number</Form.Label>
                                      <Select
                                        options={fetchedWaba}
                                        placeholder={"Select Number"}
                                        className="mb-0"
                                        value={condition.waba}
                                        onChange={(selectedOption) => {
                                          handleConditionChange(
                                            index,
                                            "waba",
                                            selectedOption
                                          );
                                          setErrors({
                                            ...errors,
                                            conditions: "",
                                          });
                                        }}
                                      />
                                    </Form.Group>
                                  ) : (
                                    <Form.Group
                                      as={Col}
                                      xs={12}
                                      className="mb-4"
                                    >
                                      <Form.Label>Route</Form.Label>
                                      <Select
                                        disabled
                                        options={routeOptions}
                                        placeholder={"Select Route"}
                                        className="mb-0"
                                        value={condition.route}
                                        onChange={(selectedOption) => {
                                          handleConditionChange(
                                            index,
                                            "route",
                                            selectedOption
                                          );
                                          setErrors({
                                            ...errors,
                                            conditions: "",
                                          });
                                        }}
                                      />
                                    </Form.Group>
                                  )}

                                  <Form.Group
                                    as={Col}
                                    xs={12}
                                    className="d-flex"
                                  >
                                    <Form.Group
                                      as={Col}
                                      xs={3}
                                      md={3}
                                      className="mb-4"
                                    >
                                      <Form.Label>Variable</Form.Label>
                                      <Select
                                        options={condVars}
                                        // isMulti
                                        placeholder={"-Variable-"}
                                        className="mb-0"
                                        value={condition.var}
                                        onChange={(selectedOption) => {
                                          setSelectedVar(selectedOption);
                                          handleConditionChange(
                                            index,
                                            "var",
                                            selectedOption
                                          );
                                        }}
                                      />
                                    </Form.Group>
                                    <Form.Group
                                      as={Col}
                                      xs={9}
                                      md={9}
                                      className="ms-2 mb-4"
                                    >
                                      <Form.Label>Short URL</Form.Label>
                                      <Select
                                        options={shortUrlList}
                                        placeholder={"Select ShortUrl"}
                                        className="mb-0"
                                        value={condition.shortUrl}
                                        onChange={(selectedOption) => {
                                          handleConditionChange(
                                            index,
                                            "shortUrl",
                                            selectedOption
                                          );
                                        }}
                                      />
                                      {errors.template && (
                                        <Form.Text className="text-danger">
                                          {errors.template}
                                        </Form.Text>
                                      )}
                                    </Form.Group>
                                  </Form.Group>

                                  <Form.Group xs={12} as={Col}>
                                    <FormCheck type="switch">
                                      <FormCheck.Input
                                        type="checkbox"
                                        checked={condition.tracking}
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "tracking",
                                            e.target.checked
                                          )
                                        }
                                      />
                                      <FormCheck.Label
                                        htmlFor="trackSwitch"
                                        style={{ marginLeft: "8px" }}
                                      >
                                        Tracking URL
                                      </FormCheck.Label>
                                    </FormCheck>
                                  </Form.Group>
                                  {errors.conditions && (
                                    <div className="text-danger">
                                      {errors.conditions}
                                    </div>
                                  )}
                                </Row>
                              ))}
                          </Form.Group>

                          {/* {campType === "WEB" && */}
                          <>
                            <Form.Group
                              as={Col}
                              xs={6}
                              lg={6}
                              className={`highlight-col ${
                                dataType ? "active" : ""
                              }`}
                            >
                              <Form.Label>Select Data Type :</Form.Label>
                              <Form.Check
                                name="dataType"
                                type="radio"
                                id="addressbook"
                                label="Address Book"
                                value="addressbook"
                                checked={dataType === "addressbook"}
                                onChange={handleDataType}
                                className={
                                  dataType === "addressbook" ? "highlight" : ""
                                }
                              />
                              <Form.Check
                                name="dataType"
                                type="radio"
                                id="api"
                                label="API List"
                                value="api"
                                checked={dataType === "api"}
                                onChange={handleDataType}
                              />
                              <Form.Check
                                name="dataType"
                                type="radio"
                                id="File"
                                label="File Upload"
                                value="File"
                                checked={dataType === "File"}
                                onChange={handleDataType}
                                className={
                                  dataType === "File" ? "highlight" : ""
                                }
                              />
                              {errors.dataType && (
                                <Form.Text className="text-danger">
                                  {errors.dataType}
                                </Form.Text>
                              )}
                            </Form.Group>

                            {dataType === "addressbook" && (
                              <Form.Group
                                as={Col}
                                xs={6}
                                lg={6}
                                className="highlight-form highlight-col"
                              >
                                <Form.Label>
                                  Select From Contact Lists
                                </Form.Label>
                                <Select
                                  options={contactList}
                                  placeholder="Select Contact"
                                  className="mb-0"
                                  value={contact}
                                  onChange={(selectedOption) => {
                                    setContact(selectedOption);
                                    handleInput(selectedOption);
                                  }}
                                  onInputChange={(inputValue, { action }) => {
                                    if (action === "input-change") {
                                      if (contactSearchTimeoutRef.current) {
                                        clearTimeout(contactSearchTimeoutRef.current);
                                      }
                                      contactSearchTimeoutRef.current = setTimeout(() => {
                                        fetchCampaignList(inputValue || "");
                                      }, 300);
                                    }
                                  }}
                                  isSearchable
                                />
                                {errors.contact && (
                                  <Form.Text className="text-danger">
                                    {errors.contact}
                                  </Form.Text>
                                )}
                              </Form.Group>
                            )}

                            {dataType === "api" && (
                              <Form.Group
                                as={Col}
                                xs={6}
                                lg={6}
                                className="px-4 highlight-form highlight-col"
                              >
                                <Form.Label>Select From API Lists</Form.Label>
                                <Select
                                  options={contactList}
                                  placeholder="Select API"
                                  className="mb-0"
                                  value={api}
                                  onChange={(selectedOption) => {
                                    setApi(selectedOption);
                                    handleInput(selectedOption);
                                  }}
                                  onInputChange={(inputValue, { action }) => {
                                    if (action === "input-change") {
                                      if (contactSearchTimeoutRef.current) {
                                        clearTimeout(contactSearchTimeoutRef.current);
                                      }
                                      contactSearchTimeoutRef.current = setTimeout(() => {
                                        fetchCampaignList(inputValue || "");
                                      }, 300);
                                    }
                                  }}
                                  isSearchable
                                />
                                {errors.api && (
                                  <Form.Text className="text-danger">
                                    {errors.api}
                                  </Form.Text>
                                )}
                              </Form.Group>
                            )}

                            {dataType === "File" && (
                              <>
                                <Col className="mt-3 mr-1 mt-sm-0 highlight-form highlight-col">
                                  <a
                                    href={`${process.env.REACT_APP_API_PORT}/download_contact_list_sample`}
                                  >
                                    &#42;Click here to download Sample File.
                                  </a>
                                  <DropFilesForm
                                    onFilesUploaded={handleContactForm}
                                  />
                                </Col>
                                {errors.file && (
                                  <Form.Text className="text-danger">
                                    {errors.file}
                                  </Form.Text>
                                )}
                              </>
                            )}
                          </>
                          {/* } */}
                        </Row>
                      </div>
                    )}

                    {step === 3 && (
                      <div>
                        <Row>
                          <Form.Group className="mb-3">
                            <Form.Label>Schedule :</Form.Label>
                            <div
                              className="d-flex justify-content-start align-items-center"
                              style={{ gap: "1rem" }}
                            >
                              <Form.Check
                                type="radio"
                                id="oneTime"
                                label="One-Time"
                                name="activeSchedule"
                                value="OneTime"
                                checked={scheduling === "OneTime"}
                                onChange={handleScheduleChange}
                              />
                              <Form.Check
                                type="radio"
                                id="recurring"
                                label="Recurring"
                                name="activeSchedule"
                                value="Recurring"
                                checked={scheduling === "Recurring"}
                                onChange={handleScheduleChange}
                              />
                              <Button
                                variant="secondary"
                                onClick={handleDateTime}
                                className="ms-auto"
                              >
                                {sendNow ? "Sending Now" : "Send Now"}
                              </Button>
                            </div>
                            {errors.scheduling && (
                              <div className="text-danger">
                                {errors.scheduling}
                              </div>
                            )}
                          </Form.Group>
                        </Row>
                        <>
                          {" "}
                          {scheduling !== "OneTime" ? (
                            <>
                              <Row>
                                <Col style={{ paddingRight: "0" }}>
                                  <Form.Group style={{ marginBottom: "20px" }}>
                                    <Form.Label>Start Date :</Form.Label>
                                    <Datetime
                                      closeOnSelect={true}
                                      dateFormat="YYYY-MM-DD" // Only date format
                                      timeFormat={false} // Disable time selection
                                      onChange={handleStartChange}
                                      className="custom-datetime-picker"
                                      renderInput={(props, openCalendar) => (
                                        <InputGroup style={{ width: "250px" }}>
                                          <InputGroup.Text>
                                            <CalendarIcon width={20} />
                                          </InputGroup.Text>
                                          <Form.Control
                                            required
                                            type="text"
                                            placeholder="Start Date"
                                            value={
                                              startDate
                                                ? startDate.format("YYYY-MM-DD")
                                                : ""
                                            }
                                            onFocus={openCalendar}
                                            style={{
                                              width: "170px",
                                              display: "inline-block",
                                            }}
                                            onChange={() => {
                                              setErrors({
                                                ...errors,
                                                startDate: "",
                                              });
                                            }} // Leave empty
                                          />
                                        </InputGroup>
                                      )}
                                    />
                                    {errors.startDate && (
                                      <div className="text-danger">
                                        {errors.startDate}
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>

                                <Col style={{ paddingLeft: "0" }}>
                                  <Form.Group style={{ marginBottom: "0" }}>
                                    <Form.Label>End Date :</Form.Label>
                                    <Datetime
                                      closeOnSelect={true}
                                      dateFormat="YYYY-MM-DD" // Only date format
                                      timeFormat={false} // Disable time selection
                                      onChange={handleEndChange}
                                      isValidDate={(currDate) =>
                                        currDate.isSameOrAfter(startDate)
                                      } // Only allow dates after startDate
                                      className="custom-datetime-picker"
                                      renderInput={(props, openCalendar) => (
                                        <InputGroup style={{ width: "250px" }}>
                                          <InputGroup.Text>
                                            <CalendarIcon width={20} />
                                          </InputGroup.Text>
                                          <Form.Control
                                            required
                                            type="text"
                                            placeholder="End Date"
                                            value={
                                              endDate
                                                ? endDate.format("YYYY-MM-DD")
                                                : ""
                                            }
                                            onFocus={openCalendar}
                                            style={{
                                              width: "170px",
                                              display: "inline-block",
                                            }}
                                            onChange={() => {
                                              setErrors({
                                                ...errors,
                                                endDate: "",
                                              });
                                            }} // Leave empty
                                          />
                                        </InputGroup>
                                      )}
                                    />
                                    {errors.endDate && (
                                      <div className="text-danger">
                                        {errors.endDate}
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>

                                <Col style={{ paddingRight: "0" }}>
                                  <Form.Group style={{ marginBottom: "0" }}>
                                    <div
                                      className="d-flex justify-content-start"
                                      style={{ gap: "1rem" }}
                                    >
                                      <div>
                                        <Form.Label>
                                          Campaign Execution Time
                                        </Form.Label>
                                        <Datetime
                                          closeOnSelect={true}
                                          timeFormat="HH:mm"
                                          dateFormat={false} // Disable the date format to hide the date
                                          onChange={handleStartTimeChange}
                                          className="custom-datetime-picker"
                                          renderInput={(
                                            props,
                                            openCalendar
                                          ) => (
                                            <InputGroup
                                              style={{ width: "250px" }}
                                            >
                                              {" "}
                                              {/* Set a fixed width */}
                                              <InputGroup.Text>
                                                <ClockIcon width={20} />{" "}
                                                {/* Keep only the clock icon */}
                                              </InputGroup.Text>
                                              <Form.Control
                                                required
                                                type="text"
                                                placeholder="Start Time"
                                                value={
                                                  startTime
                                                    ? startTime.format("HH:mm")
                                                    : ""
                                                }
                                                onFocus={openCalendar}
                                                style={{ width: "170px" }}
                                                onChange={() => {
                                                  setErrors({
                                                    ...errors,
                                                    startTime: "",
                                                  });
                                                }} // Leave empty
                                              />
                                            </InputGroup>
                                          )}
                                        />
                                      </div>

                                      <div></div>
                                    </div>
                                    {errors.startTime && (
                                      <div className="text-danger">
                                        {errors.startTime}
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>
                              </Row>

                              <Row>
                                <Form.Group className="mt-3">
                                  <Form.Label>Active Period :</Form.Label>
                                  <div
                                    className="d-flex justify-content-start"
                                    style={{ gap: "1rem" }}
                                  >
                                    <Form.Check
                                      type="radio"
                                      id="weekly"
                                      label="Weekly"
                                      name="activePeriod"
                                      value="Weekly"
                                      checked={activePeriod === "Weekly"}
                                      onChange={handlePeriodChange}
                                    />
                                    <Form.Check
                                      type="radio"
                                      id="monthly"
                                      label="Monthly"
                                      name="activePeriod"
                                      value="Monthly"
                                      checked={activePeriod === "Monthly"}
                                      onChange={handlePeriodChange}
                                    />
                                  </div>
                                  <div className="mt-2 mb-2">
                                    {activePeriod === "Weekly" &&
                                      renderWeekdaysButtons()}
                                    {activePeriod === "Monthly" &&
                                      renderDaysButtons()}
                                  </div>
                                  {errors.activePeriod && (
                                    <div className="text-danger">
                                      {errors.activePeriod}
                                    </div>
                                  )}
                                  {errors.selectedWeekdays && (
                                    <div className="text-danger">
                                      {errors.selectedWeekdays}
                                    </div>
                                  )}
                                  {errors.selectedDays && (
                                    <div className="text-danger">
                                      {errors.selectedDays}
                                    </div>
                                  )}
                                </Form.Group>
                              </Row>
                            </>
                          ) : (
                            <Row>
                              <Col style={{ paddingRight: "0" }}>
                                <Form.Group style={{ marginBottom: "20px" }}>
                                  <Form.Label>Start Date</Form.Label>
                                  <Datetime
                                    closeOnSelect={true}
                                    timeFormat={false} // Disable time selection
                                    dateFormat="YYYY-MM-DD"
                                    onChange={handleStartChange}
                                    className="custom-datetime-picker"
                                    renderInput={(props, openCalendar) => (
                                      <InputGroup style={{ width: "250px" }}>
                                        <InputGroup.Text>
                                          <CalendarIcon width={20} />
                                        </InputGroup.Text>
                                        <Form.Control
                                          required
                                          type="text"
                                          placeholder="Start Date & Time"
                                          value={
                                            moment.isMoment(startDate)
                                              ? startDate.format("YYYY-MM-DD")
                                              : ""
                                          }
                                          onFocus={openCalendar}
                                          style={{ width: "170px" }}
                                          onChange={() => {}} // Leave empty
                                        />
                                      </InputGroup>
                                    )}
                                  />
                                  {errors.startDate && (
                                    <div className="text-danger">
                                      {errors.startDate}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col style={{ paddingRight: "0" }}>
                                <Form.Group style={{ marginBottom: "0" }}>
                                  <div
                                    className="d-flex justify-content-start"
                                    style={{ gap: "1rem" }}
                                  >
                                    <div>
                                      <Form.Label>
                                        Campaign Execution Time
                                      </Form.Label>
                                      <Datetime
                                        closeOnSelect={true}
                                        timeFormat="HH:mm" // Time format for the picker
                                        dateFormat={false} // Disable date format to hide the date
                                        onChange={handleStartTimeChange}
                                        className="custom-datetime-picker"
                                        renderInput={(props, openCalendar) => (
                                          <InputGroup
                                            style={{ width: "250px" }}
                                          >
                                            <InputGroup.Text>
                                              <ClockIcon width={20} />{" "}
                                            </InputGroup.Text>
                                            <Form.Control
                                              required
                                              type="text"
                                              placeholder="Start Time"
                                              value={
                                                startTime
                                                  ? startTime.format("HH:mm")
                                                  : ""
                                              }
                                              onFocus={openCalendar}
                                              onChange={(e) => {
                                                handleStartTimeChange(
                                                  moment(
                                                    e.target.value,
                                                    "HH:mm",
                                                    true
                                                  )
                                                );
                                                setErrors({
                                                  ...errors,
                                                  startTime: "",
                                                });
                                              }} // Handle keyboard input
                                              style={{ width: "170px" }}
                                            />
                                          </InputGroup>
                                        )}
                                      />
                                    </div>
                                  </div>
                                  {errors.startTime && (
                                    <div className="text-danger">
                                      {errors.startTime}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>
                          )}
                        </>
                      </div>
                    )}
                  </div>
                </Form>
            </Card>
            <div className="mt-3 d-flex justify-content-end m-1">
              <Button
                className={`btn btn-prev me-2 ${step === 1 ? "disabled" : ""}`}
                onClick={handlePrev}
                disabled={step === 1}
                variant="secondary"
              >
                Prev
              </Button>
              {step === totalSteps ? (
                <Button
                  className="btn btn-next"
                  onClick={handlePreview}
                  variant="secondary"
                >
                  Preview
                </Button>
              ) : (
                <Button
                  className={`btn btn-next ${
                    step === totalSteps ? "disabled" : ""
                  }`}
                  onClick={handleNext}
                  disabled={step === totalSteps}
                  variant="secondary"
                >
                  Next
                </Button>
              )}
            </div>
          </div>

          {/*----preview----*/}
          {previewMobileScreens()}
        </div>
      </div>

      {/* -------------------------------------modals----------------------------------- */}

      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={showDefault}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title className="h6">Campaign Preview</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Card className="mb-2 mt-2">
            <Row>
              <Col md={11}>
                <Table
                  responsive
                  className="table-centered table-nowrap rounded mb-0"
                >
                  <tbody>
                    {/* Campaign Details */}
                    <tr>
                      <td className="border-0">Campaign Name</td>
                      <td className="border-0">{campaignName || "N/A"}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Message Type</td>
                      <td className="border-0">{selected || "N/A"}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Template</td>
                      <td className="border-0">{template?.label || "N/A"}</td>
                    </tr>
                    <tr>
                      <td className="border-0">
                        {selected === "SMS" ? "Route" : "WABA Number"}
                      </td>
                      <td className="border-0">
                        {selected === "SMS"
                          ? selectedRoute?.value || "N/A"
                          : selectedNumber?.value}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-0">Short URL</td>
                      <td className="border-0">
                        {selectedUrl?.label || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-0">Data Type</td>
                      <td className="border-0">
                        {{
                          addressbook: "Address Book",
                          API: "API List",
                          FILE: "File",
                          // apiPush: 'API Push',
                        }[dataType] || "Unknown"}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-0">
                        {{
                          addressbook: "Address Book Detail",
                          API: "API List Detail",
                          FILE: "Uploaded File",
                          apiPush: "API Push Detail",
                        }[dataType] || "Details"}
                      </td>
                      <td className="border-0">
                        {dataType === "addressbook"
                          ? contact?.label
                          : dataType === "api"
                          ? api?.label
                          : "N/A"}
                      </td>
                    </tr>
                    {/* Conditions */}
                    <tr>
                      <td className="border-0">Condition</td>
                      <td className="border-0">
                        {conditions.length >= 1 && showCondition
                          ? conditions.map((condition, index) => (
                              <div key={`${condition.id}-${index}`}>
                                {index + 1}. {condition.type || "N/A"} {"=>"}{" "}
                                {condition.message || "N/A"} {"=>"}
                                Template ID: {condition.template || "N/A"}
                              </div>
                            ))
                          : "No Conditions"}
                      </td>
                    </tr>

                    {dataType !== "apiPush" && (
                      <>
                        {/* Scheduling Details */}
                        <tr>
                          <td className="border-0">Schedule</td>
                          <td className="border-0">{scheduling || "N/A"}</td>
                        </tr>
                        <tr>
                          <td className="border-0">Start Date</td>
                          <td className="border-0">
                            {moment.isMoment(startDate)
                              ? startDate.format("YYYY-MM-DD")
                              : "N/A"}
                          </td>
                        </tr>

                        {/* Recurring Details */}
                        {scheduling !== "OneTime" && (
                          <>
                            <tr>
                              <td className="border-0">End Date</td>
                              <td className="border-0">
                                {endDate
                                  ? moment(endDate).format("YYYY-MM-DD")
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <td className="border-0">Active Period</td>
                              <td className="border-0">
                                {activePeriod || "N/A"}
                              </td>
                            </tr>
                            {activePeriod === "Weekly" && (
                              <tr>
                                <td className="border-0">Weekday</td>
                                <td className="border-0">
                                  {selectedWeekdays === 0
                                    ? "Sunday"
                                    : selectedWeekdays === 1
                                    ? "Monday"
                                    : selectedWeekdays === 2
                                    ? "Tuesday"
                                    : selectedWeekdays === 3
                                    ? "Wednesday"
                                    : selectedWeekdays === 4
                                    ? "Thursday"
                                    : selectedWeekdays === 5
                                    ? "Friday"
                                    : "Saturday"}
                                </td>
                              </tr>
                            )}
                            {activePeriod === "Monthly" && (
                              <tr>
                                <td className="border-0">Month Date</td>
                                <td className="border-0">{selectedDays}</td>
                              </tr>
                            )}
                          </>
                        )}

                        {/* Start Time */}
                        <tr>
                          <td className="border-0">Start Time</td>
                          <td className="border-0">
                            {startTime ? startTime.format("HH:mm") : "N/A"}
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
              <Col md={1} className="d-flex align-items-start">
                <Card.Body className="d-flex flex-column">
                  <div>
                    {copied ? (
                      <Button
                        size="sm"
                        variant="success"
                        className="copy-code-button"
                      >
                        Copied
                      </Button>
                    ) : (
                      <CopyToClipboard
                        text={`Campaign Name:${
                          campaignName || "N/A"
                        }\nData Type:${
                          {
                            addressbook: "Address Book",
                            API: "API List",
                            FILE: "File",
                            apiPush: "API Push",
                          }[dataType] || "Unknown"
                        }\nDetails:${
                          {
                            addressbook: "Address Book Detail",
                            API: "API List Detail",
                            FILE: "Uploaded File",
                            apiPush: "API Push Detail",
                          }[dataType] || "Details"
                        }\nMessage Type:${selected || "N/A"}\nTemplate:${
                          template?.value || "N/A"
                        }\nTemplate Content:${
                          templateContents || "N/A"
                        }\nConditions:${
                          conditions.length > 0 && showCondition
                            ? conditions
                                .map(
                                  (condition, index) =>
                                    `${index + 1}. ${
                                      condition.type || "N/A"
                                    }=>${
                                      condition.message || "N/A"
                                    }=>Template ID:${
                                      condition.template || "N/A"
                                    }`
                                )
                                .join("\n")
                            : "No Conditions"
                        }${
                          dataType !== "apiPush"
                            ? ` \nScheduling:${
                                scheduling || "N/A"
                              }\nStart Date:${
                                startDate
                                  ? startDate ||
                                    moment(startDate).format("YYYY-MM-DD")
                                  : "N/A"
                              }\nEnd Date:${
                                endDate
                                  ? moment(endDate).format("YYYY-MM-DD")
                                  : "N/A"
                              }\nActive Period:${
                                activePeriod || "N/A"
                              }\nWeekday:${
                                selectedWeekdays === 0
                                  ? "Sunday"
                                  : selectedWeekdays === 1
                                  ? "Monday"
                                  : selectedWeekdays === 2
                                  ? "Tuesday"
                                  : selectedWeekdays === 3
                                  ? "Wednesday"
                                  : selectedWeekdays === 4
                                  ? "Thursday"
                                  : selectedWeekdays === 5
                                  ? "Friday"
                                  : "Saturday"
                              }\nMonth Date:${
                                selectedDays || "N/A"
                              }\nStart Time:${
                                startTime
                                  ? moment(startTime).format("HH:mm:ss")
                                  : "N/A"
                              }`
                            : ""
                        }`}
                        onCopy={handleCopy}
                      >
                        <Button
                          size="sm"
                          variant="secondary"
                          className="copy-code-button"
                        >
                          Copy
                        </Button>
                      </CopyToClipboard>
                    )}
                  </div>
                </Card.Body>
              </Col>
            </Row>
          </Card>

          {/* <Card className="mb-2 mt-3">
                        <Row>
                            <Col md={12}>
                                <Card.Body>
                                    <b>Share Details:</b>
                                    <FormCheck type="switch" className="mt-2">
                                        <FormCheck.Input
                                            type="checkbox"
                                            id="emailSwitch"
                                            checked={selectedOption === 'email'}
                                            onChange={() => setSelectedOption('email')}
                                        />
                                        <FormCheck.Label htmlFor="emailSwitch" style={{ marginLeft: '8px' }}>
                                            Email ID
                                        </FormCheck.Label>
                                    </FormCheck>
                                    <FormCheck type="switch" className="mt-2">
                                        <FormCheck.Input
                                            type="checkbox"
                                            id="phoneSwitch"
                                            checked={selectedOption === 'phone'}
                                            onChange={() => setSelectedOption('phone')}
                                        />
                                        <FormCheck.Label htmlFor="phoneSwitch" style={{ marginLeft: '8px' }}>
                                            Phone Number
                                        </FormCheck.Label>
                                    </FormCheck>
                                    <FormCheck type="switch" className="mt-2">
                                        <FormCheck.Input
                                            type="checkbox"
                                            id="bothSwitch"
                                            checked={selectedOption === 'both'}
                                            onChange={() => setSelectedOption('both')}
                                        />
                                        <FormCheck.Label htmlFor="bothSwitch" style={{ marginLeft: '8px' }}>
                                            Both
                                        </FormCheck.Label>
                                    </FormCheck>
                                    <FormCheck type="switch" className="mt-2">
                                        <FormCheck.Input
                                            type="checkbox"
                                            id="noneSwitch"
                                            checked={selectedOption === ''}
                                            onChange={() => setSelectedOption('')}
                                        />
                                        <FormCheck.Label htmlFor="noneSwitch" style={{ marginLeft: '8px' }}>
                                            None
                                        </FormCheck.Label>
                                    </FormCheck>
                                </Card.Body>
                            </Col>
                        </Row>
                    </Card> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={showPreview}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            {{
              addressbook: "Address Book",
              API: "API List",
              FILE: "File",
              apiPush: "API Push",
            }[dataType] || "Unknown"}{" "}
            Preview
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Card className="mb-2 mt-2">
            <Row>
              <Col md={12}>
                <Table
                  responsive
                  className="table-centered table-nowrap rounded mb-0"
                >
                  <tbody>
                    {/* Privew popup */}
                    <tr>
                      <td className="border-0">Channel Name</td>
                      <td className="border-0">{selected || "N/A"}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Campaign Name</td>
                      <td className="border-0">{campaignName || "N/A"}</td>
                    </tr>
                    <tr>
                      <td className="border-0">File Name</td>
                      <td className="border-0">{contact?.label || "N/A"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card>

          <Card className="mb-2 mt-3">
            <Row>
              <Col md={12}>
                <Table
                  responsive
                  className="table-centered table-nowrap rounded mb-0"
                >
                  <tbody>
                    {/* Privew popup */}
                    <tr>
                      <td className="border-0">Total Contacts</td>
                      <td className="border-0">{tr}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Valid Contacts</td>
                      <td className="border-0">{vr}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Duplicate Contacts</td>
                      <td className="border-0">{ir}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card>

          {/* <Card>
                        <Row>
                            <Col md={12}>
                                <Table responsive className="table-centered table-nowrap rounded mb-0">
                                    <tbody>
                                        <tr>
                                            <td className="border-0 text-danger" colSpan="2" style={{ textAlign: 'center' }}>
                                                Your amount is low
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Card> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {/* new template */}
      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={templateModal}
        onHide={handleCloseTemplate}
      >
        <Modal.Header>
          <Modal.Title className="h6">Create SMS Template</Modal.Title>
          <Button
            variant="close"
            aria-label="Close"
            onClick={handleCloseTemplate}
          />
        </Modal.Header>
        <Modal.Body style={{ width: "auto" }}>
          {submitted ? (
            <div className="py-3 px-5 text-center">
              {progress !== 100 ? (
                <span className="modal-icon display-1">
                  <ClockIcon className="icon icon-xl" />
                </span>
              ) : variant === "tertiary" ? (
                <span className="modal-icon display-1">
                  <CheckCircleIcon className="icon icon-xl" />
                </span>
              ) : (
                <span className="modal-icon display-1">
                  <ShieldExclamationIcon className="icon icon-xl" />
                </span>
              )}

              <Modal.Title className="mb-3">
                {progress !== 100 ? (
                  <h3>Sending Request</h3>
                ) : variant === "tertiary" ? (
                  <h3>Template '{newTempName}' Created Successfully.</h3>
                ) : (
                  <h3>Something Went Wrong</h3>
                )}
              </Modal.Title>
              <ProgressBar
                variant="secondary"
                now={progress}
                min={0}
                max={100}
                animated
              />
              {variant !== "tertiary" ? (
                <p className="mb-4 text-danger">{reason}</p>
              ) : (
                ""
              )}
            </div>
          ) : (
            <Form
              noValidate
              validated={validated}
              onSubmit={submitNewTemp}
              autoComplete="off"
            >
              <Row className="p-2">
                <Form.Group as={Col} lg={6} className="withChars mb-3">
                  <Form.Label>
                    Template Name <span className="text-danger"> * </span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    placeholder="abc"
                    maxLength={100}
                    onChange={(e) => setNewTempName(e.target.value)}
                  />
                  <p className="chars_count">
                    {newTempName === null ? "0" : newTempName.length}
                    /100
                  </p>
                  {tempErrors.name && (
                    <div className="invalid-feedback d-block">
                      Name is required.
                    </div>
                  )}
                </Form.Group>
                <Col md={6}>
                  <Form.Group id="category">
                    <Form.Label>
                      Select Classification{" "}
                      <span className="text-danger"> * </span>
                    </Form.Label>
                    <Select
                      options={categoryOptions}
                      placeholder="Select Category"
                      className="mb-0"
                      isSearchable={true}
                      value={selectedCategory}
                      onChange={(selectedOption) => {
                        setSelectedCategory(selectedOption);
                      }}
                    />
                    {tempErrors.classification && (
                      <div className="invalid-feedback d-block">
                        Classification is required.
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={12} className="mt-3">
                  <Form.Group className="mb-3 withChars">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Template Text <span className="text-danger"> * </span>
                      </Form.Label>
                      <button
                        type="button"
                        className="ms-auto emojiPicker me-2"
                        onClick={toggleEmojiPicker}
                      >
                        <FaSmile />
                      </button>

                      {showEmojiPicker && (
                        <div ref={emojiPickerRef} className="emojiPickerBox">
                          <EmojiPicker onEmojiClick={handleEmojiClick} />
                        </div>
                      )}
                      <Button
                        onClick={AddAuthVars}
                        bsPrefix="text"
                        style={{
                          border: "none",
                          background: "none",
                          padding: 0,
                          color: "inherit",
                        }}
                        className="d-flex align-items-center text-info fw-bold"
                      >
                        <IoMdAddCircle className="icon icon-xs me-2" />
                        Add Variable
                      </Button>
                    </div>
                    <Form.Control
                      as="textarea"
                      rows="15"
                      required
                      placeholder="Enter Message Content"
                      name="template_content" // Ensure this matches the state field you are updating
                      value={newTemplatetext} // Bind textarea value to message state
                      onChange={handleChange} // Handle input changes
                      ref={textareaRef}
                    />
                    <p className="chars_count ta">
                      {newTemplatetext === undefined
                        ? "0"
                        : newTemplatetext.length}
                    </p>
                    {tempErrors.tempText && (
                      <div className="invalid-feedback d-block">
                        Classification is required.
                      </div>
                    )}
                  </Form.Group>
                  <SmsCalculator
                    text={newTemplatetext || ""}
                    onCalculation={handleCalculation} // Pass the callback to SmsCalculator
                  />
                  <ListGroup horizontal className="border-0 flex-wrap">
                    <ListGroup.Item variant="info">
                      Encoding:{smsDetails.encoding}
                    </ListGroup.Item>
                    <ListGroup.Item variant="info">
                      Character Count: {smsDetails.textLength}/
                      {smsDetails.remaining}
                    </ListGroup.Item>
                    <ListGroup.Item variant="info">
                      SMS Segments: {smsDetails.numberOfSMS}
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
              </Row>
              <div className="d-flex my-2">
                <Button variant="secondary" type="submit" className="ms-auto">
                  Submit
                </Button>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};
